var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyes = function SvgEyes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 2.932c-3.37 0-6.15 2.695-6.15 6.065 0 3.37 2.738 6.065 6.15 6.065 3.411 0 6.15-2.696 6.15-6.065 0-3.37-2.78-6.065-6.15-6.065Zm0 8.423c-1.306 0-2.401-1.053-2.401-2.358 0-1.306 1.053-2.359 2.4-2.359 1.306 0 2.402 1.053 2.402 2.359s-1.053 2.358-2.401 2.358Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.05.32C6.995.32 2.32 3.732.088 8.997c2.232 5.265 6.907 8.677 11.962 8.677 5.054 0 9.771-3.412 11.962-8.677C21.822 3.732 17.146.32 12.05.32Zm0 15.248c-3.665 0-6.655-2.949-6.655-6.571s2.99-6.57 6.655-6.57c3.664 0 6.655 2.948 6.655 6.57 0 3.622-2.99 6.57-6.655 6.57Z",
    fill: "#757575"
  })));
};

export default SvgEyes;